import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const NewsletterSubscription = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e?.preventDefault();
    if (!email) return;

    setIsLoading(true);
    
    // Simulate API call
    setTimeout(() => {
      setIsSubscribed(true);
      setIsLoading(false);
      setEmail('');
    }, 1500);
  };

  if (isSubscribed) {
    return (
      <div className="bg-success/10 border border-success/20 rounded-brand p-6 text-center">
        <div className="w-16 h-16 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={32} color="var(--color-success)" />
        </div>
        <h3 className="text-lg font-semibold mb-2">Successfully Subscribed!</h3>
        <p className="text-muted-foreground">
          Thank you for subscribing to REXFEL Market Intelligence. You'll receive our weekly insights directly in your inbox.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 border border-primary/10 rounded-brand p-6">
      <div className="text-center mb-6">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Mail" size={32} color="var(--color-primary)" />
        </div>
        <h3 className="text-xl font-semibold mb-2">Stay Ahead of the Market</h3>
        <p className="text-muted-foreground">
          Get weekly market analysis, investment insights, and exclusive content from REXFEL's expert team delivered to your inbox.
        </p>
      </div>
      <form onSubmit={handleSubscribe} className="space-y-4">
        <Input
          type="email"
          placeholder="Enter your email address"
          value={email}
          onChange={(e) => setEmail(e?.target?.value)}
          required
          className="text-center"
        />
        
        <Button
          type="submit"
          variant="default"
          fullWidth
          loading={isLoading}
          disabled={!email}
          className="bg-gradient-to-r from-primary to-accent hover:from-primary/90 hover:to-accent/90"
        >
          <Icon name="Send" size={16} />
          <span className="ml-2">Subscribe to Newsletter</span>
        </Button>
      </form>
      <div className="mt-4 text-center">
        <p className="text-xs text-muted-foreground">
          Join 5,000+ investors • Unsubscribe anytime • GDPR compliant
        </p>
      </div>
    </div>
  );
};

export default NewsletterSubscription;